import { render, staticRenderFns } from "./mvmTable.vue?vue&type=template&id=2069d504"
import script from "./mvmTable.vue?vue&type=script&lang=js"
export * from "./mvmTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2069d504')) {
      api.createRecord('2069d504', component.options)
    } else {
      api.reload('2069d504', component.options)
    }
    module.hot.accept("./mvmTable.vue?vue&type=template&id=2069d504", function () {
      api.rerender('2069d504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/mvmTable.vue"
export default component.exports